import { Component } from '@angular/core';

import { StorageService } from '../../services/storage.service';
import { TranslateModule } from '@ngx-translate/core';
import { DocumentsService } from '../../services/documents.service';
import { firstValueFrom } from 'rxjs';
import { BDCDocument } from '../../models/BDCDocument';

@Component({
    selector: 'app-teaching-sheets',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './teaching-sheets.component.html',
    styleUrl: './teaching-sheets.component.scss',
})
export class TeachingSheetsComponent {
    sheets: BDCDocument[] = [];

    constructor(
        private storageService: StorageService,
        private documentService: DocumentsService
    ) {}

    async ngOnInit() {
        await this.fetchData();
    }

    async fetchData() {
        this.sheets = await firstValueFrom(
            this.documentService.getTeachingSheets()
        );
    }

    openDoc(sheet: BDCDocument) {
        if (this.storageService.getMobile()) {
            confirm(`${sheet.url}`);
        } else {
            window.open(sheet.url, '_blank');
        }
    }
}
